
// http://esotericsoftware.com/spine-api-reference#AnimationStateListener
export const SpineEvents = {
  Start: 'start',
  End: 'end',
  Complete: 'complete',
  Interrupted: 'interrupted',
  Dispose: 'dispose',
  Event: 'event'
};
